import { I18n } from '@calendly/i18n';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import AvatarControls from './avatar_controls';
import placeholderSource from './placeholder.png';
const containerIsPhoneCss = "c15otwrg";
const containerCss = "c1hj1wlc";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} data-component="avatar-editor" className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const avatarContainerIsPhoneCss = "a19esfhv";
const avatarContainerCss = "ace1w58";
const AvatarContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(avatarContainerCss, {
    [avatarContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const imageCss = "ipsgm2n";
const Image = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} data-component="avatar-image" className={classNames(imageCss, props.className)} />;
});
export default props => <FullStoryExclude>
    <Container>
      <AvatarContainer>
        <Image alt={I18n.t('booking.avatar')} src={props.avatar || placeholderSource} />
      </AvatarContainer>
      <AvatarControls imageExists={Boolean(props.avatar)} onAvatarRemove={props.onAvatarRemove} onFileSelect={props.onFileSelect} onFileError={props.onFileError} validate={props.validate} />
    </Container>
  </FullStoryExclude>;

require("./avatar.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./avatar.js");